"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TierPricing = void 0;
var _consts = require("../../../consts");
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TierPricing = exports.TierPricing = function TierPricing(props) {
  var theme = props.theme,
    tier = props.tier,
    _props$term = props.term,
    term = _props$term === void 0 ? "yearly" : _props$term,
    isMobile = props.isMobile,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "default" : _props$variant,
    hidePricing = props.hidePricing;
  var tierConfig = _consts.boostProductTierConfig[term][tier];
  if (!tierConfig) {
    return null;
  }
  var _calculatePerMonthPri = (0, _utils.calculatePerMonthPrice)(term, tierConfig.price, tierConfig.originalPrice),
    perMonthPrice = _calculatePerMonthPri.perMonthPrice;
  var afterPromotionPrice = (0, _utils.calculatePriceAfterPromotion)(perMonthPrice, tierConfig.promoDiscountPercentage);
  var isDarkBackground = theme === "dark";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex ".concat(isMobile ? "pb-4" : "pb-6", " ").concat(variant === "compact" ? "flex-row items-center justify-between" : "flex-col"),
    style: {
      borderBottomWidth: 1,
      borderBottomColor: "#9CA3AF"
    }
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl font-bold ".concat(isDarkBackground ? "text-boost-primary-300" : "text-boost-primary-500"),
    style: {
      lineHeight: "120%"
    }
  }, "".concat((0, _utils.getBoostTierDisplayName)(tier), " Plan")), (0, _utils.getBoostTierDisplayName)(tier) === 'VIP' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(isMobile ? 'text-base' : 'text-lg', " mt-1 flex flex-row"),
    style: {
      lineHeight: "110%",
      marginBottom: "-0.5em"
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, "\uD83C\uDF1F"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold bg-gradient-to-r from-[#3C568F] to-[#4F078F] bg-clip-text text-transparent whitespace-nowrap"
  }, " Designed for Business Owners "), /*#__PURE__*/_react["default"].createElement("span", null, "\uD83C\uDF1F")), !hidePricing && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(isMobile ? "mt-4" : "mt-6", " ").concat(variant === "compact" ? "text-end" : "")
  }, tierConfig.promoActive && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex flex-row gap-3"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold ".concat(isDarkBackground ? "text-white" : "text-black", " ").concat(variant === "compact" ? "text-lg" : "text-2xl"),
    style: {
      lineHeight: "120%"
    }
  }, "$", afterPromotionPrice.toFixed(2), "/mo"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "grid text-base ".concat(isDarkBackground ? "text-white" : "text-black", " line-through items-end")
  }, "$", perMonthPrice.toFixed(2), "/mo")), !tierConfig.promoActive && /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold ".concat(isDarkBackground ? "text-white" : "text-black", " ").concat(variant === "compact" ? "text-lg" : "text-2xl"),
    style: {
      lineHeight: "120%"
    }
  }, "$", perMonthPrice.toFixed(2), " / mo"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-semibold text-xs ".concat(isDarkBackground ? "text-netural-400" : "text-neutral-600", " ").concat(variant === "compact" ? "" : "mt-2"),
    style: {
      lineHeight: "120%"
    }
  }, term === "yearly" ? "billed annually" : "billed monthly")));
};